import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogConfig } from '@angular/material';
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var PumpalertreportComponent = /** @class */ (function () {
    function PumpalertreportComponent(pumpservice, matDialog) {
        this.pumpservice = pumpservice;
        this.matDialog = matDialog;
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.columns = [];
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
    }
    PumpalertreportComponent.prototype.ngOnInit = function () {
        this.timeFilter = {
            type: "Today",
            startDate: "",
            endDate: ""
        };
        ;
        this.getpumpIds();
    };
    PumpalertreportComponent.prototype.getpumpIds = function () {
        var _this = this;
        var data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
        this.pumpservice.getPumpIds(data).subscribe(function (response1) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                console.log("ksajdhgsatdashbksankdasdvasuhjdinasuhda", response1.result);
                if (response1.result.length > 0) {
                    this.pumpIdsArray = response1.result.map(function (pump) { return pump.pump_id; });
                    this.idFilter = this.pumpIdsArray[0];
                    this.filters("pumpid", this.idFilter);
                }
                return [2 /*return*/];
            });
        }); });
    };
    PumpalertreportComponent.prototype.filters = function (type, value) {
        var _this = this;
        if (type === "pumpid") {
            this.idFilter = value;
        }
        else {
            console.log("lakskdsa", value);
            if (value === "Custom") {
                console.log('Custom filter:', value);
                var dialogConfig = new MatDialogConfig();
                var dialogRef = this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px',
                    width: '450px',
                    data: {
                        "details": "",
                        "action": "Add",
                        selectedDate: this.customeSelectedDate
                    }
                });
                dialogRef.afterClosed().subscribe(function (selectedValue) {
                    if (selectedValue) {
                        _this.customeSelectedDate = selectedValue;
                        _this.timeFilter = {
                            type: value,
                            startDate: selectedValue.startDate,
                            endDate: selectedValue.endDate
                        };
                    }
                });
            }
            else {
                this.timeFilter = {
                    type: value,
                    startDate: "",
                    endDate: ""
                };
            }
        }
        var data = { "pumpid": this.idFilter, "duration": this.timeFilter };
        this.pumpservice.alertReport(data).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data_1;
            return tslib_1.__generator(this, function (_a) {
                if (response.result.length > 0) {
                    console.log("response.result", response.result);
                    data_1 = [];
                    response.result.forEach(function (element) { data_1.push(element); });
                    this.reportColumns = this.columns.concat(Object.keys(data_1[0]));
                    this.dataSource = new MatTableDataSource(data_1);
                    this.data = data_1;
                    console.log(" let data = [];", this.data);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
                return [2 /*return*/];
            });
        }); });
    };
    PumpalertreportComponent.prototype.formatData = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataArr = [];
            dataArr.push(_this.reportColumns);
            data.forEach(function (element) {
                dataArr.push(Object.values(element));
            });
            resolve(dataArr);
        });
    };
    PumpalertreportComponent.prototype.exportToPdfs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, docDefinition;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.formatData(this.data)];
                    case 1:
                        _a.reportData = _b.sent();
                        console.log('Formatted Data:', this.reportData);
                        docDefinition = {
                            info: {
                                title: 'Transformer Report',
                            },
                            pageOrientation: 'portait',
                            pageSize: 'A0',
                            content: [
                                {
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 1,
                                        widths: ['10%', '10%', '10%', '10%', '10%'],
                                        //   body: [
                                        //      "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //     [ "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //    // [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
                                        //   ]
                                        body: this.reportData,
                                    }
                                }
                            ]
                        };
                        // const documentDefinition = { content: 'This is for testing.' };
                        pdfMake.createPdf(docDefinition).download();
                        return [2 /*return*/];
                }
            });
        });
    };
    PumpalertreportComponent.prototype.refreshData = function () {
        this.ngOnInit();
    };
    return PumpalertreportComponent;
}());
export { PumpalertreportComponent };
